import styled from "styled-components";
import { rgba } from "polished";
const SelectListOuter = styled("div")({
  alignItems: "stretch",
  flexBasis: "auto",
  flexDirection: "column",
  flexGrow: 0,
  flexShrink: 1,
  overflow: "auto",
  scrollbarWidth: "none",
  position: "relative"
});
const SelectListInner = styled("div")(
  {
    padding: "4px 0"
  },
  ({ $fadeTop }) => $fadeTop ? {
    "&::before": {
      content: JSON.stringify(""),
      display: "block",
      height: 32,
      marginTop: -32,
      pointerEvents: "none",
      position: "sticky",
      top: 0,
      background: `linear-gradient(
              to bottom,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0)
            )`
    }
  } : void 0,
  ({ $fadeBottom }) => $fadeBottom ? {
    "&::after": {
      content: JSON.stringify(""),
      display: "block",
      height: 32,
      marginTop: -32,
      pointerEvents: "none",
      position: "sticky",
      bottom: 0,
      background: `linear-gradient(
              to top,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0)
            )`
    }
  } : void 0
);
styled("section")(
  {
    padding: "0 4px"
  },
  ({ groupVariant, theme }) => ({
    divider: {
      borderBottom: `1px solid ${theme.borderColor}`,
      padding: 4,
      "&:first-child": {
        paddingTop: 0
      },
      "&:last-child": {
        borderBottom: 0,
        paddingBottom: 0
      }
    }
  })[groupVariant]
);
styled("div")(({ theme }) => ({
  color: rgba(0, 0, 0, 0.45),
  fontSize: theme.fontSize.sm,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.sm,
  padding: "4px 8px",
  textTransform: "uppercase"
}));
styled("div")(
  ({ theme }) => ({
    borderRadius: 2,
    cursor: "pointer",
    padding: "4px 8px",
    textOverflow: "ellipsis",
    "&:active": {
      backgroundColor: theme.color.gray4
    }
  }),
  ({ highlighted, theme }) => highlighted ? {
    backgroundColor: theme.color.gray3
  } : void 0,
  ({ highlighted, selected, theme }) => selected ? {
    backgroundColor: highlighted ? theme.color.blue2 : theme.color.blue1,
    color: theme.color.blue6,
    fontWeight: theme.fontWeight.medium,
    "&:active": {
      backgroundColor: theme.color.blue2
    }
  } : void 0,
  ({ indent }) => ({
    paddingLeft: indent ? 16 : void 0
  }),
  ({ $wrap }) => !$wrap ? {
    overflow: "hidden",
    whiteSpace: "nowrap"
  } : void 0
);
styled("div")(({ theme }) => ({
  color: theme.color.gray6,
  padding: "4px 8px"
}));
export {
  SelectListInner,
  SelectListOuter
};
